import React, { Component } from "react";
import styles from "./routes.module.scss";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Scrollbars from "react-custom-scrollbars-2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { withLogosticFilter } from "../../../shared/containers/containerLogosticFilter";
import { NavLink } from "react-router-dom";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import { withAuth } from "../../../shared/containers/containerAuth";

class RoutesList extends Component {
  constructor(props) {
    super(props);

    this.state = { deleteRoute: null, isDeleteModalOpen: false };
  }

  componentDidMount() {
    const { onGetLogisticRoutes, searchTerm, logisticGroupsFilter } = this.props;

    onGetLogisticRoutes({
      orderBy: "title",
      searchTerm,
      logisticGroups: logisticGroupsFilter.map((x) => {
        return x.id;
      }),
    });
  }

  onClickCreate() {
    const { onSetViewPanel, viewPanelItems, onCreateLogisticRoute } = this.props;

    onCreateLogisticRoute({ id: null, title: "Маршрут без наименования", description: null, controlPoints: [] });
    onSetViewPanel(viewPanelItems.createRoute);
  }

  onChangeClick(route) {
    const { onGetLogisticRoute, onSetViewPanel, viewPanelItems } = this.props;

    onGetLogisticRoute({ id: route.id });
    onSetViewPanel(viewPanelItems.createRoute);
  }

  onDelete(route) {
    const { onDeleteLogisticRoute } = this.props;

    onDeleteLogisticRoute(route);
  }

  render() {
    const { logisticRoutes, data } = this.props;
    const { deleteRoute, isDeleteModalOpen } = this.state;

    const height = window.innerHeight > 800 ? 650 : 450;

    const routeGetPermission = data.permissions.includes(27004);
    const routeDeletePermission = data.permissions.includes(27003);
    const routeCreatePermission = data.permissions.includes(27002);

    return (
      <div>
        <div className={styles.createToolsContainerRigth}>
          {routeCreatePermission ? (
            <TooltipWrapper title={"Создать новый маршрут"} position="left">
              <ControlPointIcon
                className={styles.icon}
                fontSize="large"
                onClick={() => {
                  this.onClickCreate();
                }}
              />
            </TooltipWrapper>
          ) : (
            <div></div>
          )}
        </div>
        <div className={styles.routesListContainer}>
          <div className={styles.createToolsContainer}>
            <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
              {logisticRoutes.map((route, index) => {
                return (
                  <div
                    key={route.id}
                    className={styles.routeItemTable}
                    style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                  >
                    <div>{route.title}</div>
                    <div>{route.description}</div>
                    <div className={styles.routeTableItemToolpanel}>
                      {routeGetPermission ? (
                        <div
                          onClick={() => {
                            this.onChangeClick(route);
                          }}
                        >
                          <TooltipWrapper title={`Просмотреть или изменить маршрут: ${route.title}`} position="top">
                            <NavLink to={`/logistic/routes/${route.id}`}>
                              <EditIcon fontSize="small" style={{ color: "black" }} />
                            </NavLink>
                          </TooltipWrapper>
                        </div>
                      ) : (
                        <div></div>
                      )}

                      {routeDeletePermission ? (
                        <div
                          style={{ width: "50px", paddingLeft: "20px" }}
                          onClick={(e) => {
                            this.setState({ isDeleteModalOpen: true, deleteRoute: route });
                          }}
                        >
                          <TooltipWrapper title={`Удалить маршрут ${route.title}`} position="top">
                            <DeleteIcon fontSize="small" />
                          </TooltipWrapper>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                );
              })}
            </Scrollbars>
          </div>

          {deleteRoute !== null ? (
            <ModalConfirmWindow isOpen={isDeleteModalOpen}>
              <DeleteConfirm
                onConfirmHandle={() => {
                  this.onDelete(deleteRoute);
                  this.setState({ isDeleteModalOpen: false, deleteRoute: null });
                }}
                onNotConfirmHandle={(e) => {
                  this.setState({ isDeleteModalOpen: false, deleteRoute: null });
                }}
                text={`Удалить маршрут "${deleteRoute.title}"?`}
              />
            </ModalConfirmWindow>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withAuth(withLogosticFilter(withLogisticRoutes(React.memo(RoutesList))));
